/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Why exact version attribution failed.
 */
export const UnknownSkillActivationReason = {
  InvalidName: "invalid_name",
  UnresolvedHash: "unresolved_hash",
  AmbiguousHash: "ambiguous_hash",
} as const;
/**
 * Why exact version attribution failed.
 */
export type UnknownSkillActivationReason = OpenEnum<
  typeof UnknownSkillActivationReason
>;

/**
 * A completed activation that could not be attributed to a skill version.
 */
export type UnknownSkillActivation = {
  /**
   * The activation observation ID.
   */
  id: string;
  /**
   * The agent provider that reported the activation.
   */
  provider: string;
  /**
   * Why exact version attribution failed.
   */
  reason: UnknownSkillActivationReason;
  /**
   * When the activation occurred.
   */
  seenAt: Date;
  /**
   * The skill name reported by the agent.
   */
  skillName: string;
  /**
   * The optional provider-specific source.
   */
  source?: string | undefined;
  /**
   * The optional source precedence level.
   */
  sourceLevel?: string | undefined;
};

/** @internal */
export const UnknownSkillActivationReason$inboundSchema: z.ZodMiniType<
  UnknownSkillActivationReason,
  unknown
> = openEnums.inboundSchema(UnknownSkillActivationReason);

/** @internal */
export const UnknownSkillActivation$inboundSchema: z.ZodMiniType<
  UnknownSkillActivation,
  unknown
> = z.pipe(
  z.object({
    id: z.string(),
    provider: z.string(),
    reason: UnknownSkillActivationReason$inboundSchema,
    seen_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    skill_name: z.string(),
    source: z.optional(z.string()),
    source_level: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "seen_at": "seenAt",
      "skill_name": "skillName",
      "source_level": "sourceLevel",
    });
  }),
);

export function unknownSkillActivationFromJSON(
  jsonString: string,
): SafeParseResult<UnknownSkillActivation, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UnknownSkillActivation$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UnknownSkillActivation' from JSON`,
  );
}
